<div class="login-page">
  <div class="custom-padding">
    <div class="login-container">
      <div class="login-image">
<!--        <img class="logo" src="/assets/images/Frame4036.png" />-->
<!--        <img class="logo2" src="/assets/images/logo2.png" />-->
        <img class="w-[14.25rem]" src="/assets/images/logo-dark.svg" />
      </div>
      <span class="login-text text-center">
        {{ "common-keywords.login" | translate }}
      </span>
      <div class="form-container">
        <form [formGroup]="fg" (submit)="login()">
          <div class="control">
            <label class="text-gray">
              {{ "common-keywords.email" | translate }}
            </label>
            <ui-input
              [autofocus]="true"
              type="text"
              formControlName="userName"
              [hasError]="
                fg.controls['userName'].touched &&
                fg.controls['userName'].invalid
              "
            ></ui-input>
          </div>
          <div
            class="danger-text"
            *ngIf="
              fg.controls['userName'].touched && fg.controls['userName'].invalid
            "
          >
            {{
              "auth.page-component.login.validation-message.valid-email"
                | translate
            }}
          </div>
          <div class="control">
            <label class="text-gray">
              {{ "common-keywords.password" | translate }}
            </label>
            <ui-password
              type="password"
              formControlName="password"
              [feedback]="false"
              [hasError]="
                fg.controls['password'].touched &&
                fg.controls['password'].invalid
              "
            ></ui-password>
            <div class="account-text">
              <label
                routerLink="/auth/forgot-password"
                class="signup text-orange forgot-pwd-text"
              >
                {{ "common-keywords.ask-forgot-password" | translate }}
              </label>
            </div>
          </div>
          <div class="control">
            <ui-button
              class="login-button"
              buttonType="submit"
              size="large"
              type="black"
              (btnClick)="login()"
              [isDisabled]="fg.invalid || !!(loading$ | async)"
              [loading]="!!(loading$ | async)"
            >
              {{ "common-keywords.login" | translate }}
            </ui-button>
          </div>
          <div class="account-text">
            <label class="text text-gray-light">
              {{ "common-messages.ask-account" | translate }}
              <label routerLink="/auth/signup" class="signup text-orange">
                {{ "common-keywords.sign-up" | translate }}
              </label>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
